import { render, staticRenderFns } from "./EditRoleButton.vue?vue&type=template&id=310746a3&"
import script from "./EditRoleButton.vue?vue&type=script&lang=js&"
export * from "./EditRoleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports